import { userConstants } from '../actions/constants/userConstants';

const initialUsers = {	
	message: '',
	items: [],
	isFilterAndTotalCountDataLoaded: false,
	itemValue: []
};

const userData = (state = initialUsers, action: any,) => {
	switch (action.type) {
		case userConstants.UserGetByFilterRequest:
			return {
				...state,
				isLoading: true,
				items: [],
				isError: false,
				isSuccess: false,
			};
		case userConstants.UserGetByFilterSuccess:
			if (!state.isFilterAndTotalCountDataLoaded) {
				return {
					...state,
					isLoading: false,
					isError: false,
					isListSuccess: true,
					isSuccess: true,
					isFilterAndTotalCountDataLoaded: true,
					status: action.payload.status,
					items: (action.payload !== "" && action.payload !== null) ? action.payload.users : [],
					totalCount: (action.payload !== "" && action.payload !== null) ? action.payload.totalCount : 1

				};
			}
			else {
				return {
					...state,
					isLoading: false,
					isError: false,
					isListSuccess: true,
					isSuccess: true,
					status: action.payload.status,
					items: (action.payload !== "" && action.payload !== null) ? action.payload.users : [],
					totalCount: (action.payload !== "" && action.payload !== null) ? action.payload.totalCount : 1
				};
			}
		case userConstants.UserGetByFilterFailure:
			return {
				...state,
				isLoading: false,
				items: [],
				isError: true,
				isListSuccess: true,
				status: action.payload
			};

		case userConstants.UserGetDetailRequest:
			return {
				...state,
				isLoading: true,
				isError: false,
				isSuccess: false,
				isDetailComplete: false,
			};
		case userConstants.UserGetDetailSuccess:
			return {
				...state,
				isLoading: false,
				isError: false,
				isDetailComplete: true,
				isSuccess: true,
				isHaveAdminRole: (action.payload.user.roles.length>0 || action.payload.user.isAdmin),
				item: action.payload.user
			};
		case userConstants.UserGetDetailFailure:
			return {
				...state,
				isLoading: false,
				isError: true,
				isDetailComplete: true,
				isHaveAdminRole:false,
				status: action.payload,
				statusCode:action.statusCode
			};

		case userConstants.UserSaveRequest:
			return {
				...state,
				isLoading: true,
				isError: false,
				isSuccess: false
			};
		case userConstants.UserSaveSuccess:
			return {
				...state,
				isLoading: false,
				isError: false,
				isSuccess: true,
				message: action.message,
				status: action.payload.status,
				roles: action.user.roles
			};
		case userConstants.UserSaveFailure:
			return {
				...state,
				isLoading: false,
				isSuccess: false,
				isError: true,
				status: action.payload
			};

		case userConstants.UserDeleteRequest:
			return {
				...state,
				isLoading: true,
				isError: false,
				isSuccess: false
			};
		case userConstants.UserDeleteSuccess:
			return {
				...state,
				isLoading: false,
				isError: false,
				isSuccess: true,
				isDeleteCompleted: true,
				status: action.payload.status
			};
		case userConstants.UserDeleteFailure:
			return {
				...state,
				isLoading: false,
				isError: true,
				isSuccess: false,
				isDeleteCompleted: true,
				status: action.payload
			};

		case userConstants.UserRoleGetByFilterRequest:
			return {
				...state,
				isLoading: true,
				rolesList: [],
				isError: false,
				isSuccess: false,
			};
		case userConstants.UserRoleGetByFilterSuccess:
			return {
				...state,
				isLoading: false,
				isError: false,
				isRoleListSuccess: true,
				isSuccess: true,
				rolesList: action.payload.roles
			};
		case userConstants.UserRoleGetByFilterFailure:
			return {
				...state,
				isLoading: false,
				isError: true,
				isListSuccess: true,
				status: action.payload,
				rolesList: []
			};

		case userConstants.UserRoleGetRequest:
			return {
				...state,
				isUserCountLoading: true,
				isSuccess: false,
				isError: false,
				isUserByRolesLoaded: false
			};
		case userConstants.UserRoleGetSuccess:
			return {
				...state,
				isUserCountLoading: false,
				isSuccess: true,
				isError: false,
				isUserByRolesLoaded: true,
				usersByRolesData: action.payload.users,
			};
		case userConstants.UserRoleGetFailure:
			return {
				...state,
				isUserCountLoading: false,
				isSuccess: false,
				isError: true,
				status: action.payload,
				isUserByRolesLoaded: false
			};

		case userConstants.UserGetCountByYearRequest:
			return {
				...state,
				isLoading: true,
				isError: false,
				isSuccess: false,
				isUserCountByYearLoaded: false
			};
		case userConstants.UserGetCountByYearSuccess:
			return {
				...state,
				isLoading: false,
				isError: false,
				isSuccess: true,
				isUserCountByYearLoaded: true,
				usersCount: action.payload
			};
		case userConstants.UserGetCountByYearFailure:
			return {
				...state,
				isLoading: false,
				isSuccess: false,
				isError: true,
				isUserCountByYearLoaded: false,
				status: action.payload
			};

		case userConstants.UserGetAddressRequest:
			return {
				...state,
				isLoading: true,
				isError: false,
				isSuccess: false,
				isUserAddressLoaded: false
			};
		case userConstants.UserGetAddressSuccess:
			return {
				...state,
				isLoading: false,
				isError: false,
				isSuccess: true,
				isUserAddressLoaded: true,
				userAddressData: action.payload
			};
		case userConstants.UserGetAddressFailure:
			return {
				...state,
				isLoading: false,
				isSuccess: false,
				isError: true,
				isUserAddressLoaded: false,
				status: action.payload,
			};

		case userConstants.UserGetPaymentRequest:
			return {
				...state,
				isLoading: true,
				isError: false,
				isSuccess: false,
				isUserPaymentLoaded: false
			};
		case userConstants.UserGetPaymentSuccess:
			return {
				...state,
				isLoading: false,
				isError: false,
				isSuccess: true,
				isUserPaymentLoaded: true,
				userPaymentData: action.payload.userPayments
			};
		case userConstants.UserGetPaymentFailure:
			return {
				...state,
				isLoading: false,
				isSuccess: false,
				isError: true,
				isUserPaymentLoaded: true,
				status: action.payload,
				userPaymentData:[]
			};

		case userConstants.UserUpdateActiveStatusRequest:
			return {
				...state,
				isLoading: true,
				isError: false,
				isSuccess: false,
				isUserAcitiveStatusLoaded: false
			};
		case userConstants.UserUpdateActiveStatusSuccess:
			return {
				...state,
				isLoading: false,
				isError: false,
				isSuccess: true,
				isUserAcitiveStatusLoaded: true,
				status: action.payload.status
			};
		case userConstants.UserUpdateActiveStatusFailure:
			return {
				...state,
				isLoading: false,
				isUserAcitiveStatusLoaded: false,
				isSuccess: false,
				isError: true,
				status: action.payload
			};

		case userConstants.UserSaveCommunityRequest:
			return {
				...state,
				isLoading: true,
				isError: false,
				isSuccess: false
			};
		case userConstants.UserSaveCommunitySuccess:
			return {
				...state,
				isLoading: false,
				isError: false,
				isSuccess: true,
				status: action.payload.status
			};
		case userConstants.UserSaveCommunityFailure:
			return {
				...state,
				isLoading: false,
				isSuccess: false,
				isError: true,
				status: action.payload
			};

		case userConstants.UserSaveAddressRequest:
			return {
				...state,
				isLoading: true,
				isError: false,
				isSuccess: false,
				isUserAddAddressLoaded: false
			};
		case userConstants.UserSaveAddressSuccess:
			return {
				...state,
				isLoading: false,
				isError: false,
				isSuccess: true,
				isUserAddAddressLoaded: true,
				status: action.payload.status
			};
		case userConstants.UserSaveAddressFailure:
			return {
				...state,
				isLoading: false,
				isSuccess: false,
				isError: true,
				isUserAddAddressLoaded: true,
				status: action.payload
			};
		case userConstants.UserRoleSaveRequest:
			return {
				...state,
				isLoading: true,
				isError: false,
				isSuccess: false,
				isUserAddRoleLoaded: false
			};
		case userConstants.UserRoleSaveSuccess:
			return {
				...state,
				isLoading: false,
				isError: false,
				isSuccess: true,
				isUserAddRoleLoaded: true,
				status: action.payload.status
			};
		case userConstants.UserRoleSaveFailure:
			return {
				...state,
				isLoading: false,
				isSuccess: false,
				isUserAddRoleLoaded: true,
				isUserRoleAddError:true,
				isError: true,
				status: action.payload
			};
		case userConstants.userAccountUpdateRequest:
			return {
				...state,
				isLoading: true,
				isError: false,
				isSuccess: false
			};
		case userConstants.userAccountUpdateSuccess:
			return {
				...state,
				isLoading: false,
				isError: false,
				isSuccess: true,
				status: action.payload.status
			};
		case userConstants.userAccountUpdateFailure:
			return {
				...state,
				isLoading: false,
				isSuccess: false,
				isError: true,
				status: action.payload
			};
		case userConstants.userGetShopifyAddressRequest:
			return {
				...state,
				isLoading: true,
				isError: false,
				isSuccess: false,
				isUserShopifyAddressLoaded: false
			};
		case userConstants.userGetShopifyAddressSuccess:
			return {
				...state,
				isLoading: false,
				isError: false,
				isSuccess: true,
				isUserShopifyAddressLoaded: true,
				userShopifyAddressData: action.payload
			};
		case userConstants.UserGetAddressFailure:
			return {
				...state,
				isLoading: false,
				isSuccess: false,
				isError: true,
				isUserShopifyAddressLoaded: false,
				status: action.payload,
			};
		default:
			return state;
	}
};

export default userData;